import styled from "styled-components";

export const ConfirmPageContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .modal {
    width: 100%;
    height: 300px;
    margin: 0 10px;
    max-width: 600px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .content-container {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
    }

    button {
      margin-top: 1rem;
      max-width: 200px;
    }

    h1 {
      font-weight: bold;
      font-size: 1.5rem;
      line-height: 122%;
      text-align: center;
      letter-spacing: -0.340547px;
      color: ${({ theme }) => theme.colors.textColor} !important;
    }

    .spin {
      display: flex;
      justify-content: center;
      margin: 30px 0;
    }
  }
`;
